import { SUPPLEMENTS_CONTAINER_ID } from '@hungryroot/rest';
import { useGetCustomerProductSubscriptionConfig } from './useGetCustomerProductSubscriptionConfig';

export function useSubscriptionWarning(): string | undefined {
  const { data } = useGetCustomerProductSubscriptionConfig();

  const subscription = data?.results[0];

  if (
    subscription === undefined ||
    subscription.container_id !== SUPPLEMENTS_CONTAINER_ID
  ) {
    return undefined;
  }

  return "Supplements that don't align will be removed from your plan.";
}
